// extracted by mini-css-extract-plugin
export default {"Title":"PlaceConfiguration_Title__vG264","Row":"PlaceConfiguration_Row__cFU0i","Tag":"PlaceConfiguration_Tag__OFpVM","Description":"PlaceConfiguration_Description__LBvcj"};